import { Text } from "native-base";

export const TableText = ({ children, ...props }) => (
  <Text fontFamily="condensed" fontWeight={500} lineHeight='sm' {...props}>
    {children}
  </Text>
);
